import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PageNotFound from '../views/PageNotFound.vue';
import ActivitiesView from '../views/ActivitiesView.vue'
import PhotosView from '../views/PhotosView.vue'
import { setMeta } from '../utils/meta'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'M4ORE SPORT 摩爾運動 | 運動防護工作室與 SportApp 管理平台',
      description: 'M4ORE SPORT（摩爾運動）為摩爾資通旗下運動科技品牌，2023 年成立。提供運動傷害處置、運動按摩、體適能檢測、運動訓練與運動防護等工作室服務，並開發 SportApp 組織級運動防護管理平台。',
      keywords: 'M4ORE SPORT, 摩爾運動, 運動防護, 運動傷害處置, 運動按摩, 體適能檢測, SportApp, 摩爾資通',
      canonical: 'https://sport.m4ore.com/'
    }
  },
  {
    path: '/ig',
    beforeEnter() {
      window.location.assign("https://www.instagram.com/m4oresport_2023", "_blank");
    }
  },
  {
    path: '/activities',
    name: 'activities',
    component: ActivitiesView,
    meta: {
      title: '活動紀錄 | M4ORE SPORT 摩爾運動',
      description: 'M4ORE SPORT 運動防護與體能訓練活動紀錄，包含合作學校、企業 ESG 健康方案與賽事防護案例。',
      keywords: 'M4ORE SPORT 活動, 運動防護案例, 賽事防護',
      canonical: 'https://sport.m4ore.com/activities'
    }
  },
  {
    path: '/photos',
    name: 'photos',
    component: PhotosView,
    meta: {
      title: '照片集 | M4ORE SPORT 摩爾運動',
      description: 'M4ORE SPORT 工作室服務、運動防護現場與企業合作的照片紀錄。',
      keywords: 'M4ORE SPORT 照片, 工作室實況, 運動防護現場',
      canonical: 'https://sport.m4ore.com/photos'
    }
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.afterEach((to) => {
  setMeta(to.meta || {})
})

export default router
